module.exports = __webpack_public_path__ + "static/encana-522547e3827e51cff438af73dde4fb68.png";